import { enUS } from "date-fns/locale";

export const customLocale = {
    ...enUS,
    options: { ...enUS.options, weekStartsOn: 1 }
};
